<template>
    <!-- 진료신청 개인정보 수집 이용 동의서-->
    <!-- <div class="agrmt_cont"> -->
    <div class="agrmt_cont">
        <div class="print">
            <h2>(진료신청) 개인정보 수집&middot;이용 동의서</h2>
            <p>[<span class="hp">{{consult.dr_name}}</span>]은 <strong>[개인정보보호법]</strong>에 의거하여 개인정보를 수집&middot;이용함에 있어 동의를 받습니다.</p>
            <ol>
                <li>
                    <h3>개인정보 수집&middot;이용 목적</h3>
                    <ul>
                        <li>- 진료 및 입원, 예약 등 진료 서비스 이용에 따른 본인 확인과 안내 절차에 사용</li>
                        <li>- 진료소식 및 안내사항 전달</li>
                        <li>- 진료비 청구, 수납, 환급 등의 원무 서비스에 사용</li>
                        <li>- 진료비 계산서, 진료비 내역서 등의 증명서 발급시 사용</li>
                        <li>- 기타 진료와 관련된 서비스에 사용</li>
                    </ul>
                </li>
                <li>
                    <h3>수집하려는 개인정보의 항목</h3>
                    <ul>
                        <li>- 이름, 주민등록번호, 건강보험가입자 성명, 연락처(전화번호/휴대폰번호)</li>
                    </ul>
                </li>
                <li>
                    <h3>개인정보의 보유 및 이용기간</h3>
                    <ul>
                        <li>- 진료기록부: 10년</li>
                        <li>- 소비자 불만 또는 분쟁처리에 관한 기록: 3년</li>
                        <li>- 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년</li>
                        <li>- 본인확인에 관한 기록: 6개월</li>
                    </ul>
                </li>
                <li>
                    <h3>동의 거부권 안내</h3>
                    <ul>
                        <li>
                            - 귀하는 개인정보 제공 동의를 거부할 권리가 있습니다.
                            <p>(단, 동의 거부 시 진료 신청이 불가능할 수 있습니다.)</p>
                        </li>
                    </ul>
                </li>
                <li>
                    <h3>제3자 제공: [의료법] 제21조 및 [개인정보보호법] 제15조에 의거하여 제공</h3>
                </li>
                <li>
                    <h3>민감정보의 수집&middot;이용</h3>
                    <ul>
                        <li>
                            - 진료서비스를 위해 민감정보(병력 및 가족력 등)를 수집&middot;이용할 수 있습니다.
                            <p>(단, 동의 거부 시 진료 신청이 불가능할 수 있습니다.)</p>
                        </li>
                    </ul>
                </li>
                <li>
                    <h3>외국인 고유식별정보(외국인등록번호, 여권번호)를 수집&middot;이용할 수 있습니다.</h3>
                    <p>(단, 동의 거부 시 진료 신청이 불가능할 수 있습니다.)</p>
                </li>
            </ol>
            <div v-if="consult.consult_user_type == 2" class="sign_area">
                <h3>&#8251;만 14세 미만 아동의 경우, 반드시 법정대리인의 동의가 필요함.</h3>
                <table>
                    <colgroup>
                        <col width="40%" />
                        <col width="60%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td scope="row">법정대리인 성 명</td>
                            <td><span class="data">{{consult.name}}</span></td>
                        </tr>
                        <tr>
                            <td scope="row">법정대리인 연락처</td>
                            <td>
                                <span v-if="note_status==0" class="data">{{ consult.phone_no ? consult.phone_no.substr(0,3) + '-****-****' : '-'}} </span>
                                <span v-else class="data">{{ consult.phone_no | phone_format }}</span>
                            </td>

                        </tr>
                        <tr>
                            <td scope="row">법정대리인과의관계</td>
                            <td><span class="data">{{ consult.consult_user_type ? get_user_type(consult.consult_user_type) : '-'  }} </span></td>
                            
                        </tr>
                    </tbody>
                </table>
                <p>&#8251;[<span class="data">{{consult.name}}</span>]은 미성년자의 법정대리인으로 [<span class="data">{{consult.dr_name}}</span>] 진료 서비스 이용 신청에 동의합니다.</p>
                <!-- <strong>동의일시 : {{consult.created_at}}</strong> -->
            </div>
            <div class="sign_area">        
                <p class="st">[<span class="data">{{consult.consult_user_name}}</span>]은 위와 같이 개인정보 수집&middot;이용에 동의합니다.</p>
                
                <strong>
                    (
                        <span v-if="note_status==0">{{ consult.consult_user_no ? consult.consult_user_no.substr(0,6) + '-*******' : '-' }} </span>
                        <span v-else>{{ consult.consult_user_no | personal_no_format }}</span>, 
                        <span v-if="note_status==0">{{ consult.phone_no ? consult.phone_no.substr(0,3) + '-****-****' : '-'}} </span>
                        <span v-else>{{ consult.phone_no | phone_format }}</span>
                    )
                </strong>
                <strong>동의일시 : {{consult.created_at}}</strong>

                <!-- <strong>{{consult}}</strong>
                <strong>{{note_status}}</strong> -->
            </div>
            <div class="chk_area">
                <p>[SMS서비스 동의]본인은 SMS발송서비스를 받기 위한 개인정보제공에 동의합니다.</p>
                <ul class="chk_box">
                    <li>
                        <input type="radio" name="sms" id="sms_y" checked="checked" disabled="disabled"/>
                        <label for="sms_y">예</label>
                    </li>
                    <li>
                        <input type="radio" name="sms" id="sms_n" disabled="disabled"/>
                        <label for="sms_n">아니오</label>
                    </li>
                </ul>
                <p>[이메일 서비스 동의] 본인은 이메일 발송서비스를 받기 위한 개인정보제공에 동의합니다.</p>
                <ul class="chk_box">
                    <li>
                        <input type="radio" name="email" id="email_y" checked="checked" disabled="disabled"/>
                        <label for="email_y">예</label>
                    </li>
                    <li>
                        <input type="radio" name="email" id="email_n" disabled="disabled"/>
                        <label for="email_n">아니오</label>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 인쇄시 해당 영역 주석처리 -->
        <!-- <button onclick="window.print();" type="button" class="btn_print">인쇄하기</button> -->
        <button @click="print" type="button" class="btn_print">인쇄하기</button>
        <div class="btn_area">
            <a role="button" class="btn_sbmt" @click="closeAgreement">확인</a>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { nameByConstMixin } from '@/lib/mixins'
    

    export default {
        mixins: [nameByConstMixin],
        name: 'agreement',
        props: ['consult_id', 'consult', 'note_status'],
        methods: {
            closeAgreement() {
                this.$emit('closeEvent');
            },
            get_user_type(u_type) {
                if(u_type==1) return '본인';
                else if(u_type==2) return '자녀';
                else if(u_type==3) return '부모';
                else return '';
            },
            print(){
                const printDiv = document.createElement("DIV");
                document.body.style.display = 'block';
                printDiv.style.display = 'none';
                const _tempHTML = document.getElementsByClassName("print")[0].innerHTML;
                const innerHTMLs = "<div class='printWrap agrmt_cont' style='width:21cm; height: 26cm;'>" + _tempHTML + "</div>";
                const popupWindow = window.open("", "_blank", "width=700,height=800");
                popupWindow.document.write(
                    "<!DOCTYPE html>"+
                    "<html>"+
                        "<head>"+
                            "<style type='text/css'>"+
                                ".endline{page-break-before:always}"+
                            "</style>"+
                            
                            "<style type='text/css'>"+
                                ".agrmt_cont{position:relative; max-width:640px; margin:0 auto; padding:20px 10px; line-height:1.4;}"+
                                ".agrmt_cont h2{margin-bottom:20px; padding:0 0 10px; border-bottom:1px solid #373a41; font-size:16px; text-align:center; color:#373a41;}"+
                                ".agrmt_cont > p{margin:0 5px 20px; font-size:12px;}"+
                                ".agrmt_cont ol{padding:0 0 20px; margin:0 25px; font-size:12px;}"+
                                ".agrmt_cont ol > li{margin-bottom:10px; list-style:decimal;}"+
                                ".agrmt_cont li h3{margin-bottom:5px;}"+
                                ".agrmt_cont li h3 + p{margin-top:-5px;}"+
                                ".agrmt_cont ol ul > li{text-indent:-8px;}"+
                                ".agrmt_cont ol ul > li p{text-indent:0;}"+
                                ".agrmt_cont .sign_area{font-size:12px; line-height:1.4;}"+
                                ".agrmt_cont .sign_area table{width:100%; margin:10px 0;}"+
                                ".agrmt_cont .sign_area table{width:100%; margin:10px 0;}"+
                                ".agrmt_cont .sign_area tr,"+
                                ".agrmt_cont .sign_area td{padding:8px 5px; border:1px solid #373a41;}"+
                                ".agrmt_cont .sign_area td:last-child{text-align:right;}"+
                                ".agrmt_cont .sign_area strong{display:block; margin:10px 0; text-align:right;}"+
                                ".agrmt_cont .sign_area .st{margin:30px -10px 0; text-align:center; font-size:13px; font-weight:bold;}"+
                                ".agrmt_cont .chk_area{position:relative; margin:20px 0; padding:15px 20px 1px; line-height:1.4; border-radius:15px; font-size:12px; background:#f5f6fa;} "+
                                ".agrmt_cont .chk_area p{font-weight:bold;}"+
                                ".agrmt_cont .chk_area p + .chk_box{margin:7px 0 14px;}"+
                                ".agrmt_cont .chk_area li{display:inline-block; margin-right:10px;}"+
                                ".agrmt_cont .chk_area input{position:absolute; left:0; opacity:0;}"+
                                ".agrmt_cont .chk_area label{position:relative; display:inline-block; height:18px; line-height:23px; padding-left:25px; vertical-align:top; font-size:14px; font-weight:bold; cursor:pointer;}"+
                                ".agrmt_cont .chk_area label:before{content:''; position:absolute; top:50%; left:0; display:inline-block; width:14px; height:14px; margin-top:-7px; border:0; border:1px solid #373a41; vertical-align:middle;}"+
                                ".agrmt_cont .chk_area input:checked+label:before{background-color:#373a41 !important; -webkit-print-color-adjust:exact; }"+
                                ".agrmt_cont .btn_area .btn_sbmt{display:block; width:100%; height:50px; line-height:50px; background:#007aff; border-radius:15px; font-size:16px; font-weight:bold; color:#fff; text-align:center; cursor:pointer;}"+
                                ".agrmt_cont .btn_print{position:absolute; top:13px; right:10px; height:30px; line-height:30px; border-radius:5px; background:#007aff; color:#fff; font-size:12px; cursor:pointer;}"+
                                ".agrmt_cont ol li{list-style: none};"+
                            "</style>"+
                            
                            // "<link href='@/assets/css/common.css' rel='stylesheet' type='text/css'>"+
                            // "<link rel='stylesheet' type='text/css' href='@/assets/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='./assets/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='/assets/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='../public/doc/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='../../public/doc/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='../../../public/doc/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='../../../../public/doc/css/sub_agreement.css'>"+
                            // "<link rel='stylesheet' type='text/css' href='../../../../../public/doc/css/sub_agreement.css'>"+
                        "</head>"+
                        "<body>"+innerHTMLs+"</body>"+
                    "</html>"
                );
                popupWindow.document.close();
                popupWindow.focus();
                //1초후 새 창 프린트
                window.setTimeout(function () {
                    popupWindow.print();
                    popupWindow.close();
                }, 1000);
            },
            
        },
        computed: {
        ...mapState(['account'])
        },
        mounted () {

        }
    }
</script>

<style scoped src="@/assets/css/sub_agreement.css">
</style>
